import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Evita que una sesión administrativa válida vuelva a montar el login al
 * usar Atrás o al escribir /login directamente. La sesión almacenada siempre
 * se valida contra el backend antes de redirigirla al panel.
 */
export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.validateStoredSession().pipe(
    map(valid => {
      if (valid) return router.createUrlTree(['/dashboard']);
      if (auth.wasLastRefreshTerminal()) return true;
      // Fallo pasajero: dentro de la app se queda donde está; en la primera
      // carga se muestra el login (antes la pantalla quedaba en blanco).
      return router.navigated ? false : true;
    }),
  );
};
